export default {
notification: {
  read: "पढ़ा हुआ",
  unread: "अपठित",
  hide: "छिपाएँ",
  showAll: "सभी दिखाएँ",
  loading: "लोड हो रहा है...",
  noMore: "कोई और डेटा नहीं",
  platform: "प्लेटफ़ॉर्म",
  personal: "व्यक्तिगत"
}
};
